module.exports = __webpack_public_path__ + "static/media/triplex_orange.6ad42936.svg";